/**
 * @desc pms-查询SKU报价详情
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.RpcSkuSupplierQuotation, options?: any) {
  return updateResponse(
    http(URL + `/getSkuSupplierQuotation`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
